export const LAYER_NAME = `Маршрут исполнителя`
export const LAYER_ID = `asignedUserLayer`
